module.exports = __webpack_public_path__ + "img/18.aae5bde4.png";